import { SOURCE } from "./constants"
import { NodeColorType, TypeProperty } from "./interface"

export class NodeColorManager {
	private colorsLeft: string[]
	private colorsRight: string[]
	private nodeColor: NodeColorType = {
		target: 0,
		source: 0,
	}

	constructor(colorsLeft: string[], colorsRight: string[]) {
		this.colorsLeft = colorsLeft
		this.colorsRight = colorsRight
	}

	getNextColor(property: TypeProperty): string {
		let color = ""
		if (property === SOURCE) {
			color = this.colorsRight[this.nodeColor[property]]
		} else {
			color = this.colorsLeft[this.nodeColor[property]]
		}

		this.nodeColor[property] += 1
		return color
	}
}
